export default "__VITE_ASSET__CW3pgc18__"